import _ from 'underscore';

export default class NewsletterService {
  constructor($http) {
    this.$http = $http;
  }

  get(filter) {
    return this.$http.post(
      '/admin/marketplace/newsletters/get_newsletters',
      {filter: filter, authenticity_token: window.token}
    );
  }

  create(newsletter) {
    return this.$http.post(
      '/admin/marketplace/newsletters/create_newsletter',
      {newsletter: newsletter, authenticity_token: window.token}
    );
  }

  delete(newsletter_id) {
    return this.$http.post(
      '/admin/marketplace/newsletters/delete_newsletter',
      {newsletter_id: newsletter_id, authenticity_token: window.token}
    );
  }

  update(newsletter) {
    return this.$http.post(
      '/admin/marketplace/newsletters/update_newsletter',
      {newsletter: newsletter, authenticity_token: window.token}
    );
  }

  find_recipients(newsletter_id, filter) {
    return this.$http.post(
      '/admin/marketplace/newsletters/find_recipients',
      {newsletter_id: newsletter_id, filter: filter, authenticity_token: window.token}
    );
  }

  add_recipients(newsletter_id, users) {
    return this.$http.post(
      '/admin/marketplace/newsletters/add_recipients',
      {newsletter_id: newsletter_id, users: users, authenticity_token: window.token}
    );
  }

  find_and_add_recipients(newsletter_id, filter) {
    return this.$http.post(
      '/admin/marketplace/newsletters/find_and_add_offer_campaign_recipients',
      {newsletter_id: newsletter_id, filter: filter, authenticity_token: window.token}
    );
  }

  get_recipients(newsletter_id, is_pending) {
    return this.$http.get(
      '/admin/marketplace/newsletters/get_newsletter_recipients',
      {params: {newsletter_id: newsletter_id, is_pending: is_pending}}
    );
  }

  set_recipient_contacts(recipient_id, contacts) {
    return this.$http.post(
      '/admin/marketplace/newsletters/set_recipient_contacts',
      {recipient_id: recipient_id, contacts: contacts, authenticity_token: window.token}
    );
  }

  auto_select_contacts(recipient_id) {
    return this.$http.post(
      '/admin/marketplace/campaigns/auto_select_recipient_contacts',
      {recipient_id: recipient_id, authenticity_token: window.token}
    );
  }

  send_email(newsletter_id, recipient_id, test_send, test_send_email) {
    return this.$http.post(
      '/admin/marketplace/newsletters/send_newsletter',
      {newsletter_id: newsletter_id, recipient_id: recipient_id, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token}
    );
  }

  set_recipient_pending(recipient_id, is_pending) {
    return this.$http.post(
      '/admin/marketplace/newsletters/set_recipient_pending',
      {recipient_id: recipient_id, is_pending: is_pending, authenticity_token: window.token}
    );
  }

  get_fields() {
    return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_fields');
  }

  update_field(field) {
    return this.$http.post(
      '/admin/marketplace/campaigns/update_offer_campaign_field',
      {field: field, authenticity_token: window.token}
    );
  }

  update_recipient_template_text(recipient_id, template_text, template_text_per, is_done) {
    return this.$http.post(
      '/admin/marketplace/campaigns/update_offer_campaign_recipient_template_text',
      {recipient_id: recipient_id, template_text: template_text, template_text_per: template_text_per, is_done: is_done, authenticity_token: window.token}
    );
  }

  copy_text_fields(source_campaign_id, target_campaign_id) {
    return this.$http.post(
      '/admin/marketplace/campaigns/copy_offer_campaign_text_fields',
      {source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token}
    );
  }

  copy_basic_infos(source_campaign_id, target_campaign_id) {
    return this.$http.post(
      '/admin/marketplace/campaigns/copy_offer_campaign_basic_infos',
      {source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token}
    );
  }

  update_recipient_embed_pi(recipient_id, embed_stocklist_pi) {
    return this.$http.post(
      '/admin/marketplace/campaigns/update_recipient_embed_pi',
      {recipient_id: recipient_id, embed_stocklist_pi: embed_stocklist_pi, authenticity_token: window.token}
    );
  }

  update_recipient_embed_matched(recipient_id, embed_stocklist_matched) {
    return this.$http.post(
      '/admin/marketplace/campaigns/update_recipient_embed_matched',
      {recipient_id: recipient_id, embed_stocklist_matched: embed_stocklist_matched, authenticity_token: window.token}
    );
  }

  get_attachments(offer_campaign_id) {
    return this.$http.get(
      '/admin/marketplace/campaigns/get_offer_campaign_attachments',
      {params: {offer_campaign_id: offer_campaign_id}}
    );
  }

  save_attachments(recipients, attachments) {
    return this.$http.post(
      '/admin/marketplace/campaigns/save_offer_campaign_recipient_attachments',
      {recipients: recipients, attachments: attachments, authenticity_token: window.token}
    );
  }

  get_default_settings(offer_title) {
    var settings = {
      campaign_id: null,
      campaign_title: offer_title,
      min_quantity: 0,
      max_embedded_matched_rows: 12,
      embed_stocklist: false,
      product_group_specs: false,
      related_offer_id: null,
      related_offer_prices: false,
      hide_offer_prices: false,
      hide_cfr_prices: false,
      hide_dap_prices: false,
      currency_symbol: 0,
      use_product_name: false,
      sort_items: false,
      sort_items_by_parent_id: false,
      use_custom_template: false,
      general_text: null,
      general_text_el: null,
      supplier_text: null,
      supplier_text_el: null,
      supplier_text_el_per: null,
      sender_name: null,
      sender_name_el: null,
      filename_stocklist: null,
      filename_stocklist_pi: null,
      special_notes: null,
      target_recipients: null,
      filter: this.get_default_filter()
    };

    return settings;
  }

  get_default_filter() {
    var filter = {
      user_countries: [],
      excluded_user_countries: [],
      excluded_user_groups: [],
      has_specs: 'all',
      user_group: 'all',
      epr_marketing_campaigns: 'all',
      business_relations: [],
      product_specs: [],
      pre_min_quality_accuracy: 1,
      pre_min_specs_accuracy: 1,
      min_quality_accuracy: 1,
      min_specs_accuracy: 1,
      specs_method_standard: true,
      specs_method_relative: false,
      specs_method_special: false,
      specs_method_advanced: false,
      specs_matching_accurate: true,
      specs_matching_flexible: true,
      specs_matching_basic_only: false,
      specs_status: 0,
      buyers: [],
      product_end_uses: [],
      match_specs_and_end_uses: false,
      specs_method_operator: 2,
      specs_method_percentage: 5,
      special_matching_method: 0, // 0 = quick, 1 = analytical
      special_matching_cuts: 1,
      special_matching_waste: 2,
      special_matching_range: 2
    };

    return filter;
  }

  set_default_settings(settings) {
    if (!settings.filter.product_specs) {
      settings.filter.product_specs = [];
    }
    if (!settings.filter.buyers) {
      settings.filter.buyers = [];
    }
    if (settings.filter.product_specs.length === 0) {
      settings.filter.product_specs.push({
        product_category_id: null,
        product_group_id: null,
        product_id: null
      });
    }
    if (!settings.currency_symbol) {
      settings.currency_symbol = 0;
    }
    if (!settings.use_product_name) {
      settings.use_product_name = false;
    }

    if (!settings.sort_items) {
      settings.sort_items = false;
    }

    if (!settings.sort_items_by_parent_id) {
      settings.sort_items_by_parent_id = false;
    }

    if (!settings.use_custom_template) {
      settings.use_custom_template = false;
    }

    if (!settings.hide_offer_prices) {
      settings.hide_offer_prices = false;
    }

    if (!settings.hide_cfr_prices) {
      settings.hide_cfr_prices = false;
    }

    if (!settings.hide_dap_prices) {
      settings.hide_dap_prices = false;
    }

    if (!settings.filter.excluded_user_groups) {
      settings.filter.excluded_user_groups = [];
    }
    
    if (!settings.filter.business_relations) {
      settings.filter.business_relations = [];
    }

    if (!settings.filter.product_end_uses) {
      settings.filter.product_end_uses = [];
    }

    if (!settings.max_embedded_matched_rows) {
      settings.max_embedded_matched_rows = 0;
    }

    if (!settings.special_notes) {
      settings.special_notes = null;
    }

    if (!settings.target_recipients) {
      settings.target_recipients = null;
    }

    if (!settings.filter.match_specs_and_end_uses) {
      settings.filter.match_specs_and_end_uses = false;
    }
    
    if (!settings.filter.specs_method_operator) {
      settings.filter.specs_method_operator = 2;
    }
    
    if (!settings.filter.specs_method_percentage) {
      settings.filter.specs_method_percentage = 5;
    }
    
    if (!settings.filter.epr_marketing_campaigns) {
      settings.filter.epr_marketing_campaigns = 'all';
    }
    
    if (!settings.filter.special_matching_method) {
      settings.filter.special_matching_method = 0;
    }
    
    if (!settings.filter.special_matching_cuts) {
      settings.filter.special_matching_cuts = 1;
    }
    
    if (!settings.filter.special_matching_waste) {
      settings.filter.special_matching_waste = 2;
    }
    
    if (!settings.filter.special_matching_range) {
      settings.filter.special_matching_range = 2;
    }

    return settings;
  }

  send_created_campaigns_email(campaigns) {
    return this.$http.post(
      '/admin/marketplace/campaigns/send_created_campaigns_email',
      {campaigns: campaigns, authenticity_token: window.token}
    );
  }

  send_campaign_sent_email(campaign_id) {
    return this.$http.post(
      '/admin/marketplace/campaigns/send_campaign_sent_email',
      {campaign_id: campaign_id, authenticity_token: window.token}
    );
  }

  get_groups() {
    return [
      {id: 1, title: 'Special'},
      {id: 4, title: 'R-Inventory'}
    ];
  }

  update_excluded_groups(groups, filter) {
    if (!filter.excluded_user_groups) {
      return;
    }

    _.each(filter.excluded_user_groups, function(group_id) {
      var group = _.findWhere(groups, {id: group_id});
      if (group) {
        group.checked = true;
      }
    });
  }
  
  update_business_relations(business_relations, filter) {
    if (!filter.business_relations) {
      return;
    }
    
    if (filter.business_relations.length > 0) {
      _.each(business_relations, function(relation) {
        relation.checked = false;
      });
    }

    _.each(filter.business_relations, function(relation_id) {
      var relation = _.findWhere(business_relations, {id: relation_id});
      if (relation) {
        relation.checked = true;
      }
    });
  }
}

NewsletterService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/newsletter.service.js